import { Cookies } from "react-cookie";

// single cookie instance
const cookies = new Cookies();

// Prefer localStorage token; fall back to cookie for backward compatibility
export const getAuthToken = () => {
  if (typeof window !== "undefined") {
    const lsToken = localStorage.getItem("authToken");
    if (lsToken) return lsToken;
  }
  return cookies.get("token");
};
